<template>
  <div id="ctl00_ContentPlaceHolder1_CalcHeader1_UpdatePanel1">
    <div class="content c895">
      <ul class="tabs">
        <li class="selected">
          <a
            id="ctl00_ContentPlaceHolder1_CalcHeader1_LinkButton1"
            title="Enotarifno merjenje"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$CalcHeader1$LinkButton1','')"
          >ENOTARIFNO MERJENJE</a>
        </li>
        <li class>
          <a
            id="ctl00_ContentPlaceHolder1_CalcHeader1_LinkButton2"
            title="Dvotarifno merjenje"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$CalcHeader1$LinkButton2','')"
          >DVOTARIFNO MERJENJE</a>
        </li>
      </ul>
      <div class="cHead">
        <div class="calculation">
          <div class="items">
            <h5>VAŠE NAPRAVE</h5>
            <ul>
              <!-- Tu izrisi vse naprave -->
            </ul>
          </div>
          <div class="first">
            <h5>VAŠA TRENUTNA PORABA</h5>
            <span id="ctl00_ContentPlaceHolder1_CalcHeader1_Label1" class="et">
              3.549 kWh / leto
              <div class="tooltip-bottom">
                Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
                <br />
                <a
                  href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                  target="_blank"
                  title="Več"
                >Več o tem &gt;</a>
              </div>
            </span>
            <em>
              <span id="ctl00_ContentPlaceHolder1_CalcHeader1_Label2">268 € / leto</span>
            </em>
          </div>
          <div id="ctl00_ContentPlaceHolder1_CalcHeader1_tdSavings">
            <h5>VAŠI PRIHRANKI</h5>
            <span id="ctl00_ContentPlaceHolder1_CalcHeader1_Label11" class="et">
              412 kWh
              <span class="save">12</span>%
              <div class="tooltip-bottom">
                Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
                <br />
                <a
                  href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                  target="_blank"
                  title="Več"
                >Več o tem &gt;</a>
              </div>
            </span>
            <em>
              <span id="ctl00_ContentPlaceHolder1_CalcHeader1_Label12">31 € / leto</span>
            </em>
          </div>
          <div id="ctl00_ContentPlaceHolder1_CalcHeader1_tdNewConsumption">
            <h5>VAŠA NOVA PORABA</h5>
            <span id="ctl00_ContentPlaceHolder1_CalcHeader1_Label6" class="et">
              3.137 kWh
              <div class="tooltip-bottom">
                Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
                <br />
                <a
                  href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                  target="_blank"
                  title="Več"
                >Več o tem &gt;</a>
              </div>
            </span>
            <em>
              <span id="ctl00_ContentPlaceHolder1_CalcHeader1_Label7">237 € / leto</span>
            </em>
          </div>
        </div>
      </div>
      <div class="extra">
        <div class="left">
          <h4>KAKO LAHKO ŠE DODATNO PRIHRANITE?</h4>
          <p
            id="ctl00_ContentPlaceHolder1_CalcHeader1_EnoTarifno"
          >Prihranki pri električni energiji so največji ob uporabi dvotarifnega merjenja, torej ob namestitvi dvotarifnega števca. Tako lahko vse energetsko potratnejše naprave uporabljate predvsem v času nižje tarife in prihranite!</p>
        </div>
        <div class="right">
          <a
            id="ctl00_ContentPlaceHolder1_CalcHeader1_LinkButton3"
            class="button"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$CalcHeader1$LinkButton3','')"
          >POGLEJ PORABO</a>

          <a
            href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
            target="_blank"
            title="Kako do dvotarifnega merjenja?"
          >Kako do dvotarifnega merjenja?</a>
        </div>
      </div>
    </div>
  </div>
  <div class="content c590">
    <div class="projection">
      <h3>PROJEKCIJA CELOTNEGA STROŠKA ZA ELEKTRIČNO ENERGIJO</h3>
      <div class="select">
        <div class="in">
          <select
            name="ctl00$ContentPlaceHolder1$ddlUsageType"
            onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
            id="ctl00_ContentPlaceHolder1_ddlUsageType"
            class="s156"
          >
            <option selected="selected" value="1">Kumulativna poraba (€)</option>
            <option value="2">Kumulativna poraba (kWh)</option>
          </select>
          <select
            name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
            onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
            id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
          >
            <option selected="selected" value="1">Za naslednje leto</option>
            <option value="5">Za naslednjih 5 let</option>
          </select>
        </div>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000004.png?4b3e9ffe-c650-4b25-9745-cf8beca2bb35"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:170px;width:568px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="509, 149, 509, 47, 509, 47, 556, 38, 556, 38, 556, 149, 509, 149"
              title="13.10.2022; 236,76251"
              alt
            />
            <area
              shape="poly"
              coords="461, 149, 461, 56, 461, 56, 509, 47, 509, 47, 509, 149, 461, 149"
              title="13.9.2022; 217,032300833333"
              alt
            />
            <area
              shape="poly"
              coords="413, 149, 413, 66, 413, 66, 461, 56, 461, 56, 461, 149, 413, 149"
              title="13.8.2022; 197,302091666667"
              alt
            />
            <area
              shape="poly"
              coords="366, 149, 366, 75, 366, 75, 413, 66, 413, 66, 413, 149, 366, 149"
              title="13.7.2022; 177,5718825"
              alt
            />
            <area
              shape="poly"
              coords="318, 149, 318, 84, 318, 84, 366, 75, 366, 75, 366, 149, 318, 149"
              title="13.6.2022; 157,841673333333"
              alt
            />
            <area
              shape="poly"
              coords="272, 149, 272, 93, 272, 93, 318, 84, 318, 84, 318, 149, 272, 149"
              title="13.5.2022; 138,111464166667"
              alt
            />
            <area
              shape="poly"
              coords="223, 149, 223, 103, 223, 103, 272, 93, 272, 93, 272, 149, 223, 149"
              title="13.4.2022; 118,381255"
              alt
            />
            <area
              shape="poly"
              coords="180, 149, 180, 112, 180, 112, 223, 103, 223, 103, 223, 149, 180, 149"
              title="13.3.2022; 98,6510458333333"
              alt
            />
            <area
              shape="poly"
              coords="132, 149, 132, 121, 132, 121, 180, 112, 180, 112, 180, 149, 132, 149"
              title="13.2.2022; 78,9208366666667"
              alt
            />
            <area
              shape="poly"
              coords="84, 149, 84, 131, 84, 131, 132, 121, 132, 121, 132, 149, 84, 149"
              title="13.1.2022; 59,1906275"
              alt
            />
            <area
              shape="poly"
              coords="37, 149, 37, 140, 37, 140, 84, 131, 84, 131, 84, 149, 37, 149"
              title="13.12.2021; 39,4604183333333"
              alt
            />
            <area
              shape="poly"
              coords="508, 149, 508, 34, 508, 34, 554, 23, 554, 23, 554, 149, 508, 149"
              title="13.10.2022; 267,860607"
              alt
            />
            <area
              shape="poly"
              coords="460, 149, 460, 44, 460, 44, 508, 34, 508, 34, 508, 149, 460, 149"
              title="13.9.2022; 245,53888975"
              alt
            />
            <area
              shape="poly"
              coords="411, 149, 411, 55, 411, 55, 460, 44, 460, 44, 460, 149, 411, 149"
              title="13.8.2022; 223,2171725"
              alt
            />
            <area
              shape="poly"
              coords="365, 149, 365, 65, 365, 65, 411, 55, 411, 55, 411, 149, 365, 149"
              title="13.7.2022; 200,89545525"
              alt
            />
            <area
              shape="poly"
              coords="317, 149, 317, 76, 317, 76, 365, 65, 365, 65, 365, 149, 317, 149"
              title="13.6.2022; 178,573738"
              alt
            />
            <area
              shape="poly"
              coords="270, 149, 270, 86, 270, 86, 317, 76, 317, 76, 317, 149, 270, 149"
              title="13.5.2022; 156,25202075"
              alt
            />
            <area
              shape="poly"
              coords="222, 149, 222, 97, 222, 97, 270, 86, 270, 86, 270, 149, 222, 149"
              title="13.4.2022; 133,9303035"
              alt
            />
            <area
              shape="poly"
              coords="179, 149, 179, 107, 179, 107, 222, 97, 222, 97, 222, 149, 179, 149"
              title="13.3.2022; 111,60858625"
              alt
            />
            <area
              shape="poly"
              coords="130, 149, 130, 118, 130, 118, 179, 107, 179, 107, 179, 149, 130, 149"
              title="13.2.2022; 89,286869"
              alt
            />
            <area
              shape="poly"
              coords="82, 149, 82, 128, 82, 128, 130, 118, 130, 118, 130, 149, 82, 149"
              title="13.1.2022; 66,96515175"
              alt
            />
            <area
              shape="poly"
              coords="36, 149, 36, 139, 36, 139, 82, 128, 82, 128, 82, 149, 36, 149"
              title="13.12.2021; 44,6434345"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282 white">
      <h3>PRIHRANKI NA POSAMEZNIH NAPRAVAH</h3>
      <div class="average">
        <h4>SKUPAJ PRIHRANKI / LETO</h4>
        <span id="ctl00_ContentPlaceHolder1_Label1">412 kWh&nbsp;&nbsp;&nbsp;31 EUR</span>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart2"
            src="/Images/Charts/Chart000005.png?912e8fe3-1a8b-4a01-ae6a-75948a2fa45b"
            alt
            style="height:170px;width:269px;border-width:0px;padding:0;"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="content c895">
    <div class="actions">
      <h3>IZVEDENI UKREPI IN PRIHRANKI</h3>

      <div class="appliance data">
        <div class="icon">
          <span class="R">Računalnik1</span>
        </div>
        <div>
          <h4>UKREPOV PRIHRANKI</h4>
          <span class="et">
            319 kWh
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
          <em>24 € / leto</em>
        </div>
        <ul>
          <li class="open">
            <a
              class="actionBtnMore"
              style="cursor:pointer;"
            >Zamenjamo računalnik z energijsko varčnejšim</a>
            <div class="details actionPnlMore" style="display: none;">
              <div class="left">
                <p>Računalnik1</p>
                <div></div>
                <div>Prenosni računalnik 12 do 14-palčni zaslon</div>
              </div>
              <div class="right">
                <span class="et">
                  259,42kWh
                  <div class="tooltip-bottom">
                    Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
                    <br />
                    <a
                      href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                      target="_blank"
                      title="Več"
                    >Več o tem &gt;</a>
                  </div>
                </span>
                <em>19,58€ / leto</em>
              </div>
            </div>
          </li>

          <li class="open">
            <a class="actionBtnMore" style="cursor:pointer;">Izklapljamo iz vtičnice</a>
            <div class="details actionPnlMore" style="display: none;">
              <div class="left">
                <p>
                  V povprečju kar
                  <b>40 odstotkov naprav</b> še vedno porablja električno energijo tudi takrat, ko so izklopljene/v stanju pripravljenosti. Strokovnjaki ocenjujejo, da tako porabimo okoli
                  <b>10 % energije</b> v gospodinjstvu. Z izklopom iz vtičnice bomo tako dosegli, da naprave ne bodo porabljale električnega toka, pomagale pa nam bodo zmanjšati račun za električno energijo. Če več naprav priklopimo na razdelilec, lahko z enim posegom izklopimo več naprav hkrati, s čimer je njihova poraba nič (=0).
                </p>
              </div>
              <div class="right">
                <span class="et">
                  59,58kWh
                  <div class="tooltip-bottom">
                    Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
                    <br />
                    <a
                      href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                      target="_blank"
                      title="Več"
                    >Več o tem &gt;</a>
                  </div>
                </span>
                <em>4,50€ / leto</em>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  methods: {},
};
</script>

<style>
</style>